module.exports = "<itpx-evaluation-material-stack-presentation [state$]=\"state$\" [materialDetails$]=\"deliverables$\">\n\n</itpx-evaluation-material-stack-presentation>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/evaluation/workflow_new/evaluation-materials/evaluation-materials.component.html
// module id = 895
// module chunks = 0